<template>
	<div class="word_book_contain">
    <!-- 头部 -->
    <div class="home_header mb-189">
			<div class="list_every home_header_main h471 box-s">
        <div class="flex ptlr-16">
          <img class="book_img" :src="data.book_cover" alt="">

          <div class="ml-16 pt-2 flex1">
            <div class="flex flex-jus">
              <div class="c1 fz-14 fw-500 wh_138_40 text-hide2">{{data.book_name}}</div>
              <div class="flexs plan_btn flex-center" @click="$router.replace('/switchplan')">切换计划 <img class="wh_6_8 ml-4" src="../../assets/img/icon/gray_right_arrow_icon.png" alt=""> </div>
            </div>
            <div class="mtb-12-8 c3 fz-12 l-h-12">学习进度：{{data.current_progress?data.current_progress:0}}/{{data.word_base}}</div>
            <div><van-progress color="#497CFF" :percentage="percentage" :show-pivot="false"/></div>
          </div>
        </div>

        <div class="adjust_main_contain pr pt-55">
          <img class="adjust_img" src="../../assets/img/bg/adjust_paln_bg.png" alt="">

          <div>
            <div class="flexs fz-14 fw-600 c1 pb-16 text-center">
              <div class="flex2">每天背诵</div>
              <div class="flex1">背诵天数</div>
            </div>

            <div class="ad_line"></div>
            
            <div class="flexs flex-jus">
              <div class="flexs flex-jus flex2">
                <div class="flex1 text-center">
                  <div class="fz-14 fw-500 c1 ptb-16">新词</div>
                  <van-picker @change="newChange"  :columns="columns1" active-class="active" :default-index="newIndex" />
                </div>
                <div class="flex1 text-center">
                  <div class="fz-14 fw-500 c1 ptb-16">复习</div>
                  <van-picker @change="newChange1" :columns="columns2" active-class="active" :default-index="oldIndex"/>
                </div>
              </div>
              <div class="flex1 text-center">
                <div class="fz-14 fw-500 c5 ptb-16">1</div>
                <van-picker @change="newChange2" :columns="columns3" active-class="active" :default-index="dayIndex"/>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>

    <!-- 按钮 -->
    <div class="btn_contain">
      <div class="blue_btn" @click="getAdjust">
        立即调整
      </div>
    </div>
	</div>
</template>
<script>
	import { addEnglishBookPlan, setEnglishBookPlan } from '@/api/api.js'
	// let isDev = process.env.NODE_ENV == "development";
	import wx from "weixin-js-sdk";
	export default {
		components: {
		},
		data() {
			return {
        columns1: [],
        columns2: [],
        columns3: [],
        data: {},
        percentage: 0,
        newIndex: 0,
        oldIndex: 0,
        dayIndex: 0
			};
		},
		created() {
      this.data = JSON.parse(this.$route.query.data)
      console.log(this.data,'this.data')
      this.percentage = this.data.word_base ? (this.data.current_progress? this.data.current_progress / this.data.word_base * 100: 0) : 0
      this.initData()
		},
		methods: {
      // 初始化列表indexdefault
      initDefaultIndex(lenght){
        if(this.data.day_study_plan || this.data.day_review_plan){
            this.newIndex = this.columns1.findIndex(item => item.split('个')[0] == this.data.day_study_plan)
            this.oldIndex = this.columns2.findIndex(item => item.split('个')[0] == this.data.day_review_plan)
            this.dayIndex = this.columns1.length - 1 - this.newIndex
        } else {
          if(lenght == 1 || lenght == 2){
            this.newIndex = 0
            this.oldIndex = 0
          } else if(lenght == 3){
            this.newIndex = 1
            this.oldIndex = 1
          } else {
            this.newIndex = 2
            this.oldIndex = 2
          } 
        }
        this.dayIndex = this.columns1.length - 1 - this.newIndex
      },
      async initData(){
        
        if(this.data.word_base > 0){
          const list = []
          const listDay = []
          for(var i = 0;i < Math.ceil(this.data.word_base / 5); i++){
            list.push(5 * (i + 1) + '个')
            listDay.push((i + 1) + '天')
          }
          this.columns1 = list
          this.columns2 = list
          this.columns3 = listDay
          this.initDefaultIndex(list.length)
          
          
        }
        
        
      },
      async getAdjust(){
        let res;
        if(this.$route.query.word){
          res = await setEnglishBookPlan({ plan_id: this.data.plan_id, study_plan: this.columns1[this.newIndex].split('个')[0], review_plan: this.columns2[this.oldIndex].split('个')[0] })
        } else {
          res = await addEnglishBookPlan({ book_id: this.data.id, study_plan: this.columns1[this.newIndex].split('个')[0], review_plan: this.columns2[this.oldIndex].split('个')[0] })
          
        }
        if(res.code == 1000){
          this.$router.replace('/wordbook')
        }else {
					 this.$toast(res.msg)
				}
        
      },
      newChange(m,values,index){
        this.newIndex = index
        this.dayIndex = Math.ceil(this.data.word_base / values.split('个')[0]) - 1
      },
      newChange1(m,values,index){
        this.oldIndex = index
      },
      newChange2(m,values,index){
        this.dayIndex = index
        this.newIndex = this.columns1.findIndex(item => item == (Math.ceil(this.data.word_base / values.split('天')[0] / 5) * 5 + '个'))
      }
    }
	};
</script>
<style lang="less" scoped>
  @import '@/assets/css/home.less';

  .adjust_img {
    position: absolute;
    top: 30px;
    left: 20px;
    width: 180px;
    height: 48px;
  }

  .ad_line {
    height: 1px;
    background: #F0EFEF;
    margin: 0 16px;
  }

  /deep/.van-picker-column__item {
    width: 100%;
    height: 42px !important;
    font-size: 16px;
  }
  .active {
    background: red !important;
  }

  /deep/.van-picker__columns {
    height: 210px !important;
  }

</style>
